export default [
    // {
	// 	path: '/prescriptions',	name: 'Prescriptions',
	// 	meta: { requiresAuth: true, section: 'prescriptions' },
	// 	component: () => import('@/views/prescriptions/Prescriptions'),
    // },
    {
		path: '/dispensations',	name: 'Dispensations',
		meta: { requiresAuth: true, section: 'dispensations' },
		component: () => import('@/views/dispensations/Dispensations'),
    },

	{
		path: '/dispensations/:id',
		name: 'DispensationDetail',
		meta: {  requiresAuth: true, section: 'dispensations'},
		component: () => import('@/views/dispensations/DispensationDetail'),
	},

    // {
	// 	path: '/medics/create',
	// 	name: 'MedicCreate',
	// 	meta: { 
	// 		requiresAuth: true,
	// 		section: 'medics'
	// 	},
	// 	component: () => import('@/views/medics/MedicFormPage'),
    // },
    // {
	// 	path: '/medics/:id',
	// 	name: 'MedicProfile',
	// 	meta: { 
	// 		requiresAuth: true,
	// 		section: 'medics'
	// 	},
	// 	component: () => import('@/views/medics/MedicProfile'),
	// },
    // {
	// 	path: '/medics/:id/update',
	// 	name: 'MedicUpdate',
	// 	meta: { 
	// 		requiresAuth: true,
	// 		section: 'medics'
	// 	},
	// 	component: () => import('@/views/medics/MedicFormPage'),
	// },	
]

